import { getCookie } from "../../utils/trainUtils";
import { railsConfig } from "../railsConfig";
import axios from 'axios';
import { generateId } from '../../utils/trainUtils';
import { MMT_AUTH } from "../../constants/TrainConstants";

export const getIrctcUserName = async () => {
  const traceId = generateId();
  let result = '';
  try {
    const mmtAuth = getCookie(MMT_AUTH);
    const url = railsConfig.getIrctcUserNameUrl;
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth,
        "X-Trace-Id": traceId
      }
    });
    result = response?.data?.primary_irctc_id || '';
  } catch (error) {
    console.error("Error in fetching IRCTC Username: ", error);
  }
  return result;
};

/** Same source as mweb `fetchSavedIrctcUsernames` — primary + irctc_ids list. */
export const getSavedIrctcUsernames = async (limit = 3): Promise<string[]> => {
  const traceId = generateId();
  try {
    const mmtAuth = getCookie(MMT_AUTH);
    if (!mmtAuth) {
      return [];
    }
    const url = railsConfig.getIrctcUserNameUrl;
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth,
        'X-Trace-Id': traceId,
      },
    });
    const data = response?.data || {};
    const max =
      typeof data.irctc_ids_limit === 'number' && data.irctc_ids_limit > 0
        ? data.irctc_ids_limit
        : limit;

    const fromList = Array.isArray(data.irctc_ids)
      ? data.irctc_ids
          .map((item: unknown) => {
            if (typeof item === 'string' || typeof item === 'number') {
              return String(item).trim();
            }
            if (item && typeof item === 'object' && 'username' in item) {
              const username = (item as { username?: unknown }).username;
              return username != null ? String(username).trim() : '';
            }
            return '';
          })
          .filter(Boolean)
      : [];

    if (fromList.length > 0) {
      return fromList.slice(0, max);
    }

    const primary = data.primary_irctc_id;
    return primary ? [String(primary)] : [];
  } catch (error) {
    console.error('Error in fetching saved IRCTC usernames: ', error);
    return [];
  }
};

export const updateIrctcUserName = async (verifiedUserId: string) => {
  const traceId = generateId();
  try {
    const mmtAuth = getCookie(MMT_AUTH);
    const url = railsConfig.updateIrctcUserName;
    const body = {
      primary_irctc_id: verifiedUserId,
    }
    await axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth,
        "X-Trace-Id": traceId
      }
    });
  } catch (error) {
    console.error("Error in updating IRCTC Username: ", error);
  }
};